import React from 'react'


function Header(){
    return(
        <div className='heading'>
            <h1>CV Application</h1>
            <h4>The Odion Project: React.JS</h4>
        </div>
    )
}

export default Header